import {
  DragDropContext,
  Draggable,
  DropResult,
  Droppable
} from 'react-beautiful-dnd';

import DeleteIcon from '@mui/icons-material/Delete';
import { FlipCardItem } from '../../../models/LessonComponentContent';
import { FlipItemEditorContainer } from './FlipItemEditorContainer';
import Grid from '@mui/material/Unstable_Grid2';
import { IconButtonWithConfirmation } from '../../../../shared/components/IconButtonWithConfirmation';
import React from 'react';
import styles from '../../../styles/FlipCard.module.scss';

interface flipItemsProps {
  flipCards: FlipCardItem[];
  componentkey: number;
  onItemChange: (card: FlipCardItem) => void;
  onItemDelete: (id: string) => void;
  onDragEnd: (result: DropResult) => void;
}

export const FlipItems = (props: flipItemsProps) => {
  const flipCards = props.flipCards;

  const getDroppableStyle = (isDraggingOver: boolean) => ({
    background: isDraggingOver ? '#eee' : 'transparent',
    height: '100%'
  });

  return (
    <DragDropContext onDragEnd={props.onDragEnd}>
      <Droppable droppableId="selection-options">
        {(provided1, snapshot1) => (
          <div
            ref={provided1.innerRef}
            style={{
              ...getDroppableStyle(snapshot1.isDraggingOver),
              width: '100%'
            }}
          >
            {flipCards?.map((card, index) => (
              <Draggable key={card.id} draggableId={card.id} index={index}>
                {(provided2, snapshot2) => (
                  <div ref={provided2.innerRef} {...provided2.draggableProps}>
                    <Grid
                      container
                      direction="row"
                      alignItems="center"
                      className={styles.itemEditorContainer}
                    >
                      <Grid style={{ flex: 11 }}>
                        <FlipItemEditorContainer
                          componentkey={props.componentkey}
                          flipCard={card}
                          provided2={provided2}
                          length={flipCards.length > 1}
                          onItemChange={props.onItemChange}
                        />
                      </Grid>
                      <Grid
                        style={{ flex: 1 }}
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="flex-start"
                      >
                        <IconButtonWithConfirmation
                          size="small"
                          onConfirm={() => props.onItemDelete(card?.id)}
                        >
                          <DeleteIcon />
                        </IconButtonWithConfirmation>
                      </Grid>
                    </Grid>
                  </div>
                )}
              </Draggable>
            ))}
            {provided1.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};
